<template><slot></slot></template>
<script>
export default {
  props: {
    label: {
      default: ''
    },
    prop: {},
    class: {
      default: ''
    },
    format: {
      type: Function
    }
  },
  name: "UiTableCol",
}
</script>
